import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useWorkspaceTaskGroups } from "@api/taskGroup.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TaskGroupFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: taskGroups = [] } = useWorkspaceTaskGroups();
    const { taskGroupIds } = filters;

    const labels = useMemo(
        () =>
            taskGroups
                .filter((taskGroup) => taskGroupIds?.includes(taskGroup.id))
                .map((taskGroup) => taskGroup.name),
        [taskGroups, taskGroupIds],
    );

    if (!taskGroupIds || taskGroupIds.length === 0) {
        return null;
    }

    return formatFilterLabel(labels);
};
